import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, ToastController} from '@ionic/angular';
import {DefaultComponent} from "../../shared/components/default.component";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";
import {PaymentsService} from "./payments.service";
import {Location} from "@angular/common";


@Component({
    selector: 'app-rfid',
    templateUrl: './payments.html',
    styleUrls: ['./payments.scss'],
})
export class Payments extends DefaultComponent implements OnInit {

    disableSelector:boolean
    payments: any = [];
    dataSource: any;
    searchTerm: string = '';
    filters: any = {};


    constructor(
        private modelCtrl: ModalController,
        router: Router,
        activatedRoute: ActivatedRoute,
        sharedRoutesService: SharedRoutesService,
        private paymentService: PaymentsService,
        toastController: ToastController,
        private _location: Location,


    ) {
        super(router, activatedRoute, sharedRoutesService, toastController);
        this.disableSelector = true;


    }
    onBack() {
        this._location.back();
    }
    ngOnInit() {
        this.filters = {
            per_page: 5
        }
    this.getPayments();
    }





    getPayments() {
        const queryParams = {
            // relationships: 'tag',
            ...this.filters
        };

        return this.paymentService
            .list(queryParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (data) => {
                    this.payments = data.data;
                    console.log('data',this.payments);

                });

    }

    setFiltered() {
        this.payments = this.payments.filter((rfid) => {
            return rfid.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
        });
    }



}
